module.exports = __webpack_public_path__ + "static/media/24077128496_cab1a7fe30_o.3093d586.jpg";